// Include jQuery
const $ = require('jquery');

// jQuery Definitionen
window.jQuery = $;
window.$ = $;

require('./vendor/html5shiv.min');
require('./vendor/jquery-download');
require('./vendor/jquery-migrate');
require('./vendor/jquery-ui');
require('./vendor/jquery-zoombox.min');
require('./vendor/modernizr.touch.svg');
require('./vendor/img_preview');
require('./vendor/gestalt');
require('./vendor/slick.min');
require('./vendor/shop');

// Include Lightbox
import PhotoSwipeLightbox from 'photoswipe/lightbox';
// Caption Plugin für PhotoSwipe
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';

/**
 * Ajax form for typo3
 * @param conf
 */
function mpAjaxForm(conf) {
  // Das erste Formular im ausgewählten Element finden
  const form = document.querySelector('form:first-of-type');

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    // Wert des input[name=ajaxform]-Felds aus dem Formular abrufen
    const ajaxForm = form.querySelector('input[name=ajaxform]').value;

    // Formular per Ajax senden?
    if (ajaxForm > 0 && form.getAttribute('enctype') !== 'multipart/form-data') {
      // Name des input[name=ajaxform]-Felds ändern
      form.querySelector('input[name=ajaxform]').setAttribute('name', 'ajax_form');

      // Formulardaten sammeln
      const form_data = new FormData(form);

      // Fetch-API für Ajax-Anfrage nutzen
      fetch(form.getAttribute('action'), {
        method: form.getAttribute('method'),
        body: form_data,
      }).then((response) => response.text()).then((html) => {
        // HTML-Code in das DOM einfügen
        const cAjaxForm = document.querySelector('#c' + ajaxForm);
        cAjaxForm.outerHTML = html;

        // Eventlistener für das neu eingefügte Formular hinzufügen
        mpAjaxForm.call('#c' + ajaxForm, conf);

        // Bei Bedarf zum neu eingefügten Formular scrollen
        const formTop = cAjaxForm.offsetTop;
        if (window.pageYOffset > formTop) {
          window.scrollTo({top: formTop, behavior: 'smooth'});
        }
      });
    }
  });
}

/**
 * Scripts asynchron laden
 */
(function($) {
  $.extend({
    loadScript: function(source, callback, cache) {
      var c = (typeof cache == 'undefined' ? true : cache);
      (function(d, t) {
        var g = d.createElement(t),
            s = d.getElementsByTagName(t)[0];
        g.src = source + (c === false ? '?_=' + new Date().getTime() : '');
        g.onload = function() {
          callback();
        };
        s.parentNode.insertBefore(g, s);
      }(document, 'script'));
    },
  });
})(jQuery);

/**
 * Ajax Lightbox
 * @param file
 * @param params
 *
 * Beispiel:
 *
 <div class="popup-header">Header</div>
 <div class="popup-body">Body</div>
 <div class="popup-footer">Footer</div>
 *
 * Aufruf:
 * <a href="#" onclick="ajaxDialog('url.php'); return false;">Link</a>
 **/
window.ajaxDialog = function(file, params) {
  var self = $(this);

  self.show = function() {
    // Wenn Dialog schon vorhanden, dann nicht mehr schließen
    if ($('html.popup-open').length === 0) {
      $(config.container).append('<div class="popup-wrap"></div>');
      $('.popup').show();
      $('.popup-close').click(function() {
        self.close();
      });
    }

    $('embed, object').css('visibility', 'hidden');

    if (typeof file == 'string') {
      self.load();
    }
    if (typeof file == 'object') {
      $('.popup-wrap').html(file.html());
      $('.popup-close').click(function() {
        self.close();
      });
    }
  };

  self.load = function() {
    const MP_HOST = `${window.location.protocol}//${window.location.host}` + '/';
    const ajaxUrl = MP_HOST + file;

    $.ajax({
      url: ajaxUrl,
      type: 'post',
      data: config.post_data,
      success: function(html) {

        setTimeout(function() {
          $('html').addClass('popup-open');
        }, 100);

        const popupWrap = $('.popup-wrap');
        popupWrap.html(html);
        $('.popup-close').click(function() {
          self.close();
        });

        if (popupWrap.find('form').attr('action') === '') {
          $('.popup-wrap form:first').on('submit', function() {
            $(this).find('.clone_model').remove();
            config.post_data = $(this).find('input[type=text], input[type=hidden], input[type=password], input[type=checkbox]:checked, input[type=radio]:checked, textarea, select').serializeArray();
            self.load();
            return false;
          });
        }
        if (typeof config.callback == 'function') {
          config.callback();
        }
      },
    });
  };

  self.close = function() {
    $('embed, object').css('visibility', 'visible');
    $('html').removeClass('popup-open');
    setTimeout(function() {
      $('.popup-wrap').remove();
    }, 150);

    dialogHistoryReset();
  };

  // Hier gehts los
  if (typeof file == 'object' && $(file).attr('href')) {
    file = $(file).attr('href');
  } else if (typeof file == 'object') {
    file = $(file);
  }

  if (file === 'close') {
    self.close();
    return;
  }

  if (typeof params != 'object') {
    params = {};
  }

  var defaults = {
    container: 'body',
    callback: function() {
    },
    post_data: {},
  };
  var config = $.extend(defaults, params);

  self.show();

  // History Open

  // ESC Dialog schliessen
  $(document).off('keyup').on('keyup', function(e) {
    if (e.keyCode === 27) {
      self.close();
    }
  });

  $('.popup-overlay').on('click', function() {
    self.close();
  });
};

/**
 * dialogChangeUrl
 * @param param
 */
window.dialogChangeUrl = function(param) {
  var currentUrl = document.location.href;
  var html = $('html');

  // Überprüfen, ob der Param bereits in der URL vorhanden ist
  if (!currentUrl.includes(param)) {
    if (!html.hasClass('history-change')) {
      if (currentUrl.indexOf('?') === -1) {
        history.pushState({}, '', currentUrl + '?' + param);
      } else {
        history.pushState({}, '', currentUrl + '&' + param);
      }
    }

    html.addClass('history-change');
  }
};

/**
 * dialogHistoryReset
 */
window.dialogHistoryReset = function() {
  // URL Change
  var currentUrl = document.location.href;

  // Entferne Parameter "openBasket" aus der URL
  var newUrl = currentUrl.replace(/[?&]openBasket/g, '');

  history.pushState({}, '', newUrl);

  var html = $('html');
  html.removeClass('history-change');
};

/**
 * getVar
 * @param var_name
 * @returns {boolean|string}
 */
window.getVar = function(var_name) {
  var query = window.location.search.substring(1);
  var vars = query.split('&');

  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (pair[0] === var_name) {
      return pair[0];
    }
  }
  return false;
};

/**
 * Macht einen Listen-Bereich sortierbar, seitenschaltbar usw.
 * @param item
 * @param get_data
 * @param params
 * @param special
 */
window.ajaxItem = function(item, get_data, params, special) {
  if (typeof item != 'string') {
    return;
  }
  if (typeof params != 'object') {
    params = {};
  }

  get_data = get_data || {};
  var self = this;
  var container_list = '#list_' + item;
  if (special) {
    container_list = '#list_special_' + special;
  }

  var defaults = {
    container: container_list,
    ajax_file: MP_PATH + 'ajax/ajax.list_' + item + '.php',
    callback: function() {
    },
  };
  var config = $.extend(defaults, params);

  this.sortBy = function(sortby) {
    self.updater({sortby: sortby});
  };

  this.changePage = function(page, search, t3page) {
    var temp = {};
    if (search) {
      temp['q'] = search;
    }
    if (t3page) {
      temp['id'] = t3page;
    }

    self.updater({page: page, q: search, id: t3page});
  };

  // Fügt weitere Elemente aus einem Object hinzu, um diese mit einem späteren
  // Aufruf von updater() zu berücksichtigen
  this.addFilter = function(name, filter) {
    if (typeof filter == 'object') {
      var filt = [];
      $(filter).each(function() {
        filt[filt.length] = $(this).val();
      });
      var temp = {};
      temp[name] = filt;
      get_data = $.extend({}, get_data, temp);
    }
  };

  /**
   * Updater
   * @param get_updater
   */
  this.updater = function(get_updater) {
    var data = (typeof get_updater != 'undefined' ? get_updater : {});

    var extendOption;
    if (pageLang !== 'de') {
      extendOption = {
        ajax: 1, LANG: pageLang,
      };
    } else {
      extendOption = {
        ajax: 1,
      };
    }

    data = $.extend(data, extendOption);

    $.ajax({
      url: config.ajax_file + '?' + $.param(get_data),
      type: 'get',
      data: data,
      beforeSend: function() {
        self.showLoader();
      },
      success: function(html) {
        $(config.container).html(html);
        self.afterLoad();
      },
    });
  };

  this.poster = function(post_data) {
    var data = (typeof post_data != 'undefined' ? post_data : {});
    data = $.extend(data, {ajax: 1});
    $.ajax({
      url: config.ajax_file,
      type: 'post',
      data: data,
      beforeSend: function() {
        self.showLoader();
      },
      success: function(html) {
        $(config.container).html(html);
        self.afterLoad();
      },
    });
  };

  this.afterLoad = function() {
    if (typeof config.callback == 'function') {
      config.callback();
    }
  };

  this.showLoader = function() {
    insertAutoLoader($(config.container));
  };
};

/**
 * Autoloader
 * @param into
 */
window.insertAutoLoader = function(into) {
  var w = $(into).width();
  var h = $(into).height();
  $(into).prepend('<div class="loader" style="position:absolute; width:' + w + 'px; height:' + h + 'px;"></div>');
};

/**
 * Open basket
 */
window.openBasket = function(params = '') {
  dialogChangeUrl('openBasket');
  ajaxDialog(MP_PATH + 'ajax/ajax.dialog_basket.php?LANG=' + pageLang + params);
};

/**
 * In Warenkorb hinzufügen
 * @param zeile
 * @param uid
 * @param num
 */
window.addToBasket = function(zeile, uid, num) {
  $.ajax({
    url: MP_PATH + 'ajax/ajax.basket_control.php',
    type: 'post',
    dataType: 'json',
    data: {
      type: 'add',
      zeile: zeile,
      uid: uid,
      num: num,
      LANG: pageLang,
    },
    success: function(res) {
      if (res.amount > 0) {
        $('i.tx-count-holder').attr('data-amount', res.amount);
      } else {
        $('i.tx-count-holder').removeAttr('data-amount');
      }

      $('span.tx-count').html(res.amount);
      ajaxDialog(MP_PATH + 'ajax/ajax.dialog_choose_product.php?uid=' + uid + '&addBasket=1&LANG=' + pageLang);
    },
  });
};

/**
 * Warenkorb bearbeiten (löschen, Menge ändern)
 * @param zeile
 * @param uid
 * @param num
 * @param refresh
 */
window.modifyBasket = function(zeile, uid, num, refresh) {
  const MP_HOST = `${window.location.protocol}//${window.location.host}` + '/';
  const file = 'ajax/ajax.basket_control.php';
  const ajaxUrl = MP_HOST + file;
  $.ajax({
    url: ajaxUrl,
    type: 'post',
    dataType: 'json',
    data: {
      type: 'mod',
      zeile: zeile,
      uid: uid,
      num: num,
      LANG: pageLang,
    },
    success: function(res) {
      if (res.amount > 0) {
        $('i.tx-count-holder').attr('data-amount', res.amount);
      } else {
        $('i.tx-count-holder').removeAttr('data-amount');
      }

      $('span.tx-count').html(res.amount);

      openBasket('&modBasket=1' + (refresh === true ? '&refresh' : ''));
    },
  });
};

/**
 * Vom Warenkorb entfernen
 * @param zeile
 * @param uid
 */
window.removeFromBasket = function(zeile, uid) {
  $.ajax({
    url: MP_PATH + 'ajax/ajax.basket_control.php',
    type: 'post',
    dataType: 'json',
    data: {
      type: 'del',
      zeile: zeile,
      uid: uid,
      LANG: pageLang,
    },
    success: function(res) {
      if (res.amount > 0) {
        $('i.tx-count-holder').attr('data-amount', res.amount);
      } else {
        $('i.tx-count-holder').removeAttr('data-amount');
      }

      $('span.tx-count').html(res.amount);
      ajaxDialog(MP_PATH + 'ajax/ajax.dialog_choose_product.php?uid=' + uid + '&delBasket=1&LANG=' + pageLang);
    },
  });
};

/**
 * switchControls
 */
window.switchControls = function() {
  var mysSelect = $('#mySelect');

  if (mysSelect.val() === 1) {
    // Deutschland
    $('#checkid').hide();
    $('#cod').closest('div.form-group').show();
  } else if (mysSelect.val() === 16) {
    // Schweiz
    $('#checkid').hide();
    $('#cod').closest('div.form-group').hide();
    if (document.getElementById('payment2')) {
      document.getElementById('payment2').checked = false;
    }
  } else {
    // andere Länder
    $('#checkid').show();
    $('#cod').closest('div.form-group').hide();
    if (document.getElementById('payment2')) {
      document.getElementById('payment2').checked = false;
    }
  }

  const shippingList = $('#shipping-list');

  $.ajax({
    url: MP_PATH + 'ajax/getShippingCost.php?LANG=' + pageLang,
    type: 'post',
    data: {
      countryID: mysSelect.val(),
      from: shippingList.attr('data-from'),
      selected: shippingList.attr('data-selected'),
    },
    success: function(html) {
      shippingList.html(html);
    },
  });
};

/**
 * isValid
 * @returns {*}
 */
window.isValid = function() {
  return document.querySelector('#acceptAGB').checked;
};

/**
 * onChangeCheckbox
 * @param handler
 */
window.onChangeCheckbox = function(handler) {
  document.querySelector('#acceptAGB').addEventListener('change', handler);
};

/**
 * toggleValidationMessage
 */
window.toggleValidation = function() {
  if (!isValid()) {
    const agbCheck = $('.agbCheck');
    $('html,body').animate({
      scrollTop: agbCheck.offset().top,
    }, 'fast');
    agbCheck.find('input[type="checkbox"]').addClass('error');
  }
};

/**
 * toggleButton
 * @param actions
 * @returns {void | *}
 */
window.toggleButton = function(actions) {
  return isValid() ? actions.enable() : actions.disable();
};

$(window).on('load', function() {
  if (location.hash !== '') {
    try {
      var targetElement = $(location.hash);
      if (targetElement.length > 0) {
        $('html,body').animate({scrollTop: targetElement.offset().top}, 500);
      }
    } catch (e) {
      console.warn(e);
    }
  }
  $('body').addClass('winload');
});

$(window).bind('hashchange', function(e) {
  e.preventDefault();
  if (location.hash !== '' && $(location.hash).length > 0) {
    $('html,body').animate({scrollTop: $(location.hash).offset().top}, 500);
  }
});

// Document Ready
document.addEventListener('DOMContentLoaded', function() {
  // CSS-Klasse wechseln, wenn JS aktiviert ist (für Fallbacks)
  document.querySelector('html').classList.replace('no-js', 'js');

  // Photoswipe config
  const lightbox = new PhotoSwipeLightbox({
    gallery: '.pswp-gallery',
    children: '.pswp-gallery__item',
    pswpModule: () => import('photoswipe'),
  });
  // Photoswipe caption
  // eslint-disable-next-line
  new PhotoSwipeDynamicCaption(lightbox, {
    // Plugins options, for example:
    type: 'below',
    captionContent: (slide) => {
      // Caption aus figcaption ziehen
      return (slide.data.element.nextElementSibling ? slide.data.element.nextElementSibling.textContent : '');
    },
  });
  lightbox.init();

  // Ajax-Formulare
  document.querySelectorAll('.ce-login').forEach(function(form) {
    mpAjaxForm.call(form, null);
  });

  // Zoombox laden und starten
  $('.zoombox').zoombox();

  // Bypass-Menu Button
  $('.ce-menu-bypass').click(function(e) {
    e.preventDefault();
    var wrap = $(this).closest('.ce-frame');
    var scrollheight = wrap.offset().top + wrap.height();
    $('html,body').animate({scrollTop: scrollheight}, 500);
  });

  // Responsive Menu
  // Menu-Button resettet die Classes vom Menü und lässt das Menü öffnen und schließen
  $('#header .menu-button').on('click', function() {
    var html = $('html');
    if (html.hasClass('menu-open')) {
      html.removeClass('menu-open').addClass('menu-delay');
      setTimeout(function() {
        html.removeClass('menu-delay');
      }, 250);
    } else {
      html.addClass('menu-open');
      $('#menu-overlay').on('click', function() {
        $('#header #menu .menu-button').trigger('click');
      });
    }
  });
  $('.submenu-open').on('click', function() {
    $(this).closest('li').toggleClass('open');
  });

  // Menüscrolling
  var tmpscrollpos = $(window).scrollTop();
  var scrollstepdif = 56;
  var scrolldepth = 80;

  if ($(window).scrollTop() >= scrolldepth + 1) {
    $('html').addClass('scrolled');
  }
  $(window).on('touchmove scroll load', function() {
    if ($(window).scrollTop() <= scrolldepth) {
      $('html').removeClass('scrolled');
    } else {
      if (((tmpscrollpos - $(this).scrollTop()) > Math.abs(scrollstepdif)) || ((tmpscrollpos - $(this).scrollTop()) < -Math.abs(scrollstepdif))) {
        if (tmpscrollpos < $(this).scrollTop()) {
          $('html').addClass('scrolled');
        } else {
          $('html').removeClass('scrolled');
        }
        tmpscrollpos = $(window).scrollTop();
      }
    }
  });

  // CE ce-container--type-teaser-img, ce-container--type-tiles-33-66: .ce-header__header Text wrappen (nicht subheader)
  $('.ce-container--type-teaser-img > .ce-container__row > .ce-container__col--1000 > .ce-frame > .ce-frame__inner header .ce-header__header,' +
      '.ce-container--type-tiles-33-66 > .ce-container__row > .ce-container__col > .ce-frame > .ce-frame__inner header .ce-header__header').each(function() {
    $($(this).prop('firstChild')).wrap('<span>');
  });

  /*
   * Tabs
   */
  // Click-Events
  $('.tabs-holder .switch-btn').click(function(e) {
    e.preventDefault();
    var ele = $(this);
    var eledata = ele.data('switch');
    var items = ele.closest('.tabs-holder').find('.switch-content .switch-entry');
    // Active-Klassen Handling
    ele.closest('.tabs-holder').find('.tabs-header .switch-btn').removeClass('on');
    ele.addClass('on');
    // Anzeigen des dazu passenden Inhalts
    items.each(function() {
      var item = $(this);
      if (item.data('switch') === eledata) {
        item.show();
      } else {
        item.hide();
      }
    });
  });
  // init
  $('.switch-entry').hide();
  $('.tabs-holder').each(function() {
    $(this).find('.tabs-header .switch-btn:first-child').trigger('click');
  });

  /*
   * Tab-Element Neu
   */
  if ($('.tab-text-wrap').length > 0) {
    // Doppelte Header entfernen
    $('.tab-text-wrap ~ .ce-frame header').remove();

    const frames = $('.tab-text-wrap + .ce-frame');
    const headers = $('.tab-text-wrap > header'); // Select all headers inside .tab-text-wrap

    // Erste Element immer ausgeklappt / active
    frames.removeClass('open').eq(0).addClass('open');
    headers.removeClass('open').eq(0).addClass('open'); // Add "open" class to the first header

    headers.click(function() {
      const index = $(this).index(); // Get index of clicked header
      const container = $(this).closest('.ce-container__col'); // Find the closest column container
      const frames = container.children('.ce-frame'); // Get only direct .ce-frame children
      const headers = $(this).siblings('header').addBack();

      // Remove "open" class from all headers and frames, then add it to the selected ones
      headers.removeClass('open');
      $(this).addClass('open');

      // Remove "open" from all frames and add it to the one that matches the index
      frames.removeClass('open').eq(index).addClass('open');
    });
  }

  /*
   * Slideshows
   */

  // Teaser-Slideshow
  // Slide
  var teaserSlider = $('.grid-teaserslider');
  var teaserSliderFor = teaserSlider.find('.grid-teaserslider-for');
  var teaserSliderNav = teaserSlider.find('.grid-teaserslider-nav');

  teaserSliderFor.slick({
    asNavFor: teaserSliderNav,
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    speed: 150,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
  });

  // Nav
  teaserSliderNav.slick({
    asNavFor: teaserSliderFor,
    infinite: true,
    arrows: false,
    draggable: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 961,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 721,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 521,
        settings: {
          slidesToShow: 1,
          fade: true,
        },
      },
    ],
  });

  // Nav und Slide anhalten wenn sich Benutzer innerhalb Teaser-Slider bewegt
  teaserSlider.on('mouseover, click', function() {
    teaserSliderFor.slick('slickPause');
  }).on('mouseleave', function() {
    teaserSliderFor.slick('slickPlay');
  });

  // Produkt Slideshow (Einzelansicht)
  var productSlider = $('.image-gallery');
  var productSliderFor = productSlider.find('.image-gallery-for');
  var productSliderNav = productSlider.find('.image-gallery-nav');

  productSliderFor.slick({
    asNavFor: productSliderNav,
    infinite: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    swipe: false,
    accessibility: false,
  });

  // Nav
  productSliderNav.slick({
    asNavFor: productSliderFor,
    infinite: false,
    arrows: true,
    draggable: false,
    swipe: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    focusOnSelect: true,
    accessibility: false,
  });

  // Produkslideshow (CE-Element)
  var productSliderHolder = $('.ce-productslider');
  if (productSliderHolder.length > 0) {
    // Klasse .noflex setzen, weil Slideshow sonst in das unendliche geht
    productSliderHolder.closest('.ce-container--type-content-100').addClass('noflex');

    productSliderHolder.find('.ce-productslider-inner').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 721,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 461,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  /*
   * Akkordion
   */
  var accordionHolder = $('.accordion-holder');
  var accordionSpeed = 250;

  // Erstes Kindelement automatisch öffnen, sollte es nicht schon offen sein
  accordionHolder.find('.accordion-item:first-child').addClass('open').children('.accordion-content').css('display', 'block');

  // Toggle-Funktion
  accordionHolder.children('.accordion-item').each(function() {
    $(this).children('.accordion-title').on('click', function() {
      // Gewünschtes öffnen
      $(this).next('.accordion-content').stop().slideToggle(accordionSpeed).parent('.accordion-item').toggleClass('open');

      // Alle anderen schliessen
      $(this).parent('.accordion-item').siblings().removeClass('open').not($(this)).children('.accordion-content').stop().slideUp(accordionSpeed);
    });
  });

  /*
   * Suche (Header)
   */
  var headerSearch = $('#header #search');
  if (headerSearch.length > 0) {
    var headerSearchSubmit = headerSearch.find('.search-submit').children('button[type="submit"]');

    headerSearch.find('.search-toggle').on('click', function() {
      if (headerSearch.hasClass('open')) {
        $(this).closest(headerSearch).removeClass('open').find('.search-input').children('input').blur();
      } else {
        $(this).closest(headerSearch).toggleClass('open').find('.search-input').children('input').focus();
      }
    });

    // Submit nur anzeigen, wenn input nicht leer
    if (headerSearch.find('.search-input').children('input').val() !== '') {
      headerSearchSubmit.prop('disabled', false);
    }
    headerSearch.find('.search-input').children('input').on('keyup bind cut copy paste', function() {
      if ($(this).val() !== '') {
        headerSearchSubmit.prop('disabled', false);
      } else {
        headerSearchSubmit.prop('disabled', true);
      }
    });
  }

  // Produktsuche Autocomplete
  const search = $('#search');
  if (search.length > 0) {
    search.submit(function() {

    }).find('input.search').autocomplete({
      source: MP_PATH + 'ajax/ajax.autocomplete.php?LANG=' + pageLang,
      appendTo: '#search > .search-group',
      minLength: 1,
      select: function(ev, ui) {
        if (ui.item.product_url) {
          location.href = ui.item.product_url;
        }
        return false;
      },
    }).focus(function() {
      $(this).data('ui-autocomplete').search($(this).val());
    }).data('ui-autocomplete')._renderItem = function(ul, item) {
      return $('<li></li>').data('item.autocomplete', item).append('<a>' + item.label + '</a>').appendTo(ul);
    };

    // Bei
    $('#search.open').find('.search-toggle').on('click', function() {
      $('.ui-menu').css('display', 'none');
    });
  }

  // Gesammelte Funktionen ausführen, weil jQuery erst im Footer geladen wird
  $(functionsAfterLoad).each(function(k, v) {
    v();
  });

  switchControls();

  $('#credit_pay').hide();
});

$.migrateMute = false;
$.curCSS = function(element, prop, val) {
  return $(element).css(prop, val);
};
